import React, { useEffect, useState, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { createColumnHelper, getCoreRowModel, getSortedRowModel, useReactTable } from '@tanstack/react-table'
import { useDispatch } from 'react-redux'

import styles from './styles.module.scss'

import { getMaintenanceAssets } from '../../../api'
import { showMaintenance } from '../../../store/asset/actions'

import Table from '../../Invoices/Table'
import AssetStatus from '../AssetStatus'

const columnHelper = createColumnHelper()

const MaintenanceUpcoming = ({companyId}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [assets, setAssets] = useState([])

  useEffect(() => {
    getAssets()
  }, [])

  const getAssets = async () => {
    const res = await getMaintenanceAssets(companyId, {type: 'upcoming'})
    if (Array.isArray(res?.data)) {
      setAssets(res.data)
    }
  }

  const handleClickAsset = (asset) => {
    dispatch(showMaintenance({asset_id: asset.id, maintenance_plan_id: asset.maintenance_plan.id}))
  }

  const columns = useMemo(() => [
    columnHelper.display({
      id: 'asset',
      header: t('Asset'),
      cell: ({ row }) => {
        return (
          <div className={styles.assetCell}>
            <div className={styles.assetName}>{row.original.name}</div>
            <div className={styles.assetCategory}>{row.original.code}</div>
          </div>
        )
      }
    }),
    columnHelper.accessor('maintenance_plan.name', {
      header: t('Plan'),
      enableSorting: false,
    }),
    columnHelper.accessor('maintenance_plan.trigger', {
      header: t('Trigger'),
      enableSorting: false,
      cell: ({getValue}) => getValue()
    }),
    columnHelper.accessor('maintenance_date', {
      header: t('Next due'),
      enableSorting: false,
      cell: ({getValue}) => getValue()
    }),
    columnHelper.accessor('employee.name', {
      header: t('Assigned to'),
      enableSorting: false,
      cell: ({row}) => row.original.employee ? `${row.original.employee.name} ${row.original.employee.surname}` : ''
    }),
    columnHelper.accessor('status', {
      enableSorting: false,
      header: t('Status'),
      cell: ({getValue}) => <AssetStatus status={getValue()} />
    }),
    columnHelper.display({
      id: 'action',
      header: t('Action'),
      cell: ({row}) => (
        <button type="button" className={styles.actionButton} onClick={() => handleClickAsset(row.original)}>
          {t('Complete')}
        </button>
      )
    })
  ], [t])

  const table = useReactTable({
    data: assets,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getRowId: row => String(row.id),
  })

  return (
    <div className={styles.container}>
      <Table table={table} columns={columns} headerClassName={styles.tableHeader} />
    </div>
  )
}

export default MaintenanceUpcoming